import store from '@/store/index'

export default {
  created: function () {
    const title = this.$options.title
    if (title) {
      store.commit('pages/setTitle', title)
    } else {
      store.commit('pages/setTitle', 'Media Management')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pages.js